import * as React from "react";
function SvgNotification(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 6c-2.171 0-5 2.038-5 6.647V17h10v-4.353C17 8.038 14.171 6 12 6zm2-1.651V4a2 2 0 10-4 0v.349c-2.71.958-5 3.862-5 8.298V19h4a3 3 0 106 0h4v-6.353c0-4.436-2.29-7.34-5-8.298zM12 20a1 1 0 01-1-1h2a1 1 0 01-1 1z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgNotification);
export default ForwardRef;
